import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';


import Most_View_Ar from './Most_View_Ar.js';
import { da } from 'date-fns/locale';





export default function Cricket_Home_Ar() {
  const jsonbasket = variables.basename_url + 'updates/index/Athlethixnet_HomeAr_Cricket.json';

  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();


  async function refda() {

    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    //



    setNisLoading(true);


    Get_Data_Cricket_Home_Ar();

  };

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])





  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data_Cricket_Home_Ar() {

    JsonArray.splice(0);  //to clear All data in your page

    setNisLoading(true);

    axios.get(jsonbasket)

      .then(function (response) {
        setNisLoading(false);

        console.log(response.data);




        for (let i = 0; i <= 3 && i < response.data.length; i++) {

          JsonArray.push({

            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split(" ")[0],
            news_imagename: response.data[i].Image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,

          })
        }
      })
  }






  return (
    <>

      <div className=" bg-white flot-right ">





        <div className="bussiness-items bg-white float-left  pl-3 pr-3">
          <br></br>
          <a href='Cricket_Ar'>
            <h3 className=" float-right bg-white  " style={{ fontSize: "24px", fontFamily: "Al-Jazeera-Bold" }}>أخبار كريكت</h3>
          </a>
          <br></br>
          <br></br>
          <br></br>

          {JsonArray.map(C =>

            <div key={C.news_title}  >

              <div className="bussiness-post-item text-right">
                <div className="bussiness-post-thumb">



                  <a href={C.link}>
                    <img className='rounded' style={{ maxWidth: '300px', maxHeight: '250px' }} src={C.news_imagename} alt="gallery" />
                  </a>
                </div>
                <div className="bussiness-post-content">
                  <h3 className="title"><a href={C.link}>{C.news_title}</a></h3>
                  {/* <a  href={ C.news_date } tabIndex={-1}>{C.news_date}</a> */}
                  <a href="#" tabIndex={-1}>
                    {new Date(C.news_date).toLocaleDateString('ar-EG')}
                  </a>


                  <div className="mt-1 ">

                    <a href={C.link}> <p className='JUUSTIFY A-Color' >{parse(C.Description)}</p></a>

                  </div>
                </div>
              </div>


            </div>

          )}
        </div>
      </div>


    </>
  );
}



